import { render, staticRenderFns } from "./ConfrimDialog.vue?vue&type=template&id=b6683c88&scoped=true&"
import script from "./ConfrimDialog.vue?vue&type=script&lang=ts&"
export * from "./ConfrimDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ConfrimDialog.vue?vue&type=style&index=0&id=b6683c88&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6683c88",
  null
  
)

export default component.exports